<template>
    <div>
  <top-navbar></top-navbar>
  <div class=" mb-5" >
      <!-- <h4 class="manage-boder">Manage Customer</h4>  -->
      <h6 class="manage-boder pt-2 font1 font-bold1"> <a class="decoration" > Home </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Service  </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/"> Settings  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Manage Service Advisor  </h6>

      <div class="container-fluid">
      <div style="border: 0px; padding: 0px; min-height:0px" class="navbar">

        <div class="d-flex">
          <b-input-group size="sm" style="width: 225px;">
            <b-form-input id="filter-input" v-model="filter" type="search" placeholder="Search">
            </b-form-input>
            
    </b-input-group>
    <div style="margin-top: 11px;" class="ms-2" >
    <span class="custom-breadcrumb"><b>Showing {{currentPage}}-{{currentPage*perPage}} of {{totalRows}} items.</b></span>
  </div>

        </div>

      <div class="d-grid gap-2 d-md-flex justify-content-md-end">
       

        <button  @click="tectCreate()"  class="btn btn-outline-primary btn-sm mb-1 mt-1">  Create Service Advisor</button>
     

        <div>
  <b-modal :id="infoModal1.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      
     bottom>
    <template   #modal-title>
     
      <h3 >Confirm !</h3>

      
  
    </template>
    
    <div class="d-block text-center">
      <h5>Are you sure you want to Confirm this item?</h5>
    </div>
    <hr>
    
    <template   #modal-footer>
    <button style="font-size: small;" @click="Confirm(infoModal1.content)" class="mr-1 btn btn-outline-primary btn-sm mb-1">Yes</button>
    <button style="font-size: small;" @click="$bvModal.hide(infoModal1.id)" class="mr-1 btn btn-outline-primary btn-sm mb-1">No</button>
    </template>

  
  </b-modal>

 
</div>
  
      </div>
    </div>
    <div class="card mt-1">
    <div class="card-body " >
<div class="d-flex justify-content-center" v-if="isLoading">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
<div v-else>


       <!-- <div style="border: 0px; padding: 0px; min-height:20px" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
      <span class="custom-breadcrumb"><b>Showing {{currentPage}}-{{currentPage*perPage}} of {{totalRows}} items.</b></span>
    </div>
    </div> -->
   
  <div class="table-responsive">
   

    <b-table responsive style="font-size: small;"  class=" table-hover "
      :items="all_datas"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
    
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      
      
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
  
      show-empty
      small
      @filtered="onFiltered"
    >
   

]
      <template #cell(actions)="row">
      
     
        <button  style=" font-size: small;"
         @click="Viewpage(row.item.id)" class="mr-1 btn   btn-outline-primary btn-sm mb-1">
          View
        </button>
      
        <button  style=" font-size: small;"
         @click="Update(row.item.id)"  class="mr-1 btn  btn-outline-primary btn-sm mb-1">
         Update
        </button>
       
       
        <button   class="btn btn-sm  btn-outline-primary mb-1"> Inactive</button>
       
      </template>

      <template #cell(number)="row">
        {{ row.index + 1 === 10 ? currentPage * 10 : currentPage - 1 + row.index + 1 }}
       
        
      </template>
      <template #cell(P_code1)="row">
       <a href="/" > {{ row.item.P_code }}</a>
</template>

     
    </b-table>



    <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-4">
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="fill"
        size="sm"
        class="my-0"
      ></b-pagination>
    </b-col>

  </div>

  </div>
 
  <b-modal   :id="infoModal.id" :title="infoModal.content.C_code"  hide-footer >
    <div class="card">
      <div class="card-body">


        <table style="font-size: small; " class="table  table-sm  ">
       
          <tbody >
   
            <tr >
              <td style="border: 0px;" ><b>Id </b></td>
             <td style="border: 0px;">{{ infoModal.content.idCustomer }}</td> 
            </tr>
            <tr>
              <td><b>Name of Homeowner </b></td>
             <td>{{ infoModal.content.C_name }}</td> 
            </tr>
            <tr>
              <td><b>Address Line 1 </b></td>
             <td>{{ infoModal.content.C_address_line1 }}</td> 
            </tr>
           
            <tr>
              <td><b>Address Line 2 </b></td>
             <td>{{ infoModal.content.C_address_line2 }}</td> 
            </tr>
            <tr>
              <td><b>Address Line 3 </b></td>
             <td>{{ infoModal.content.C_address_line3 }}</td> 
            </tr>
            <tr>
              <td><b>Apt Phone </b></td>
             <td>{{ infoModal.content.C_contact_tel1 }}</td> 
            </tr>
            <tr>
              <td><b>Service charge/<br> Sinking fund </b></td>
             <td>{{ infoModal.content.billing_type }}</td> 
            </tr>
            <tr>
              <td><b>Created Date </b></td>
             <td>{{ infoModal.content.C_created_date }}</td> 
            </tr>
           
             
          </tbody>
   
   
        </table>

      </div>
    </div>

  </b-modal>
  
  
  </div>
    </div>

    <br><br>
  </div>
  </div>

  <content-footer></content-footer>
</div>
  
  
  </template>
  
  <script>
      import jsPDF from 'jspdf';
   import 'jspdf-autotable';
   import axios from 'axios';
   import authService from '@/auth.service';
   import TopNavbar from './../../layout/TopNavbar.vue';
   import ContentFooter from './../../layout/ContentFooter.vue'
  
  
  
  
  export default {
    components :{
       
        TopNavbar,
        ContentFooter,
        
    },
  
      mounted(){
    this.loadMiinventory()
      },
     
      computed: {
        
  
  
  
      },
  
      data(){
      return{
        isModalOpen: false,
        all_datas:[],
      search: "",

      alldata: {},
      all_code: {},
      sinvo: {},
      details: [],
      total: {},
      rec_dets: {},



      access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        totalRows: 1,
        currentPage: 1,
        perPage:10,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
       
        fields: [
          { key: 'number', label: '#', sortable: true, sortDirection: 'desc' },
          { key: 'name1', label: 'Name', sortable: true,  },
          { key: 'area', label: 'Area', sortable: true  },
          { key: 'contact_no', label: 'Contact No', sortable: true  },
          { key: 'created_date', label: 'Created Date', sortable: true  },
          { key: 'username', label: 'Created By', sortable: true  },
          { key: 'status1', label: 'Status', sortable: true  },
          { key: 'actions', label: 'Actions', sortable: true , class:'width-custom8', },
          
        ],
          
        infoModal: {
          id: 'info-modal',
          title: '',
          content: {},
        },
        infoModal1: {
          id: 'info-modal1',
          title: '',
          content: {},
        },
        isLoading: true, 
        variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark','mycoolor'],
        headerBgVariant: 'mycoolor',
        headerTextVariant: 'light',
       
       
      };
      },
  
      
  
  
     methods:{ 


     
  
      async info(idCustomer) {
    console.log(idCustomer);
    try {
      const { data} = await  axios.get('/mcustomer/view?id='+idCustomer,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.infoModal.content = data.item_list
       this.$root.$emit('bv::show::modal', this.infoModal.id)
      
      
    } catch (error) {
      console.log(error.response);
    }
  },

  async Viewpage(id) {
  
    this.$router.push('/mserviceadvisor/view?id='+id);
   
  },
 
  async Update(id){
        this.$router.push('/mserviceadvisor/update?id='+id);
      },
      async tectCreate(id){
        this.$router.push('/mserviceadvisor/create');
      },
     

    //   async Confimmodel(id){
    //     this.infoModal1.content = id;
    //    this.$root.$emit('bv::show::modal', this.infoModal1.id);
      
    //   },
  
      serchCustom(id) {

    this.filterOn = id;
    },

    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
  
      async loadMiinventory() {
       
    
      try {
        const { data} = await  axios.get('/mserviceadvisor/index',{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.all_datas = data.all_data;
         this.totalRows = this.all_datas.length;
         this.isLoading = false; 
        
      } catch (error) {
        console.log(error.response);
      }
    },

    async Confirm(id) {
      
    
       try {
         const { data} = await  axios.get('/sinvoice/confirm?id='+id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadMiinventory();
           
            this.$root.$emit('bv::hide::modal', this.infoModal1.id);
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },
     
  
   
  
  
  
  
  
  }
  
  
  
  
  };
  
  </script>
  
  <style >


  .button1{
    width: 10px !important;
  }
  .border1{
    border: none;
    background-color: #0d6efd;
  }
  .font-color1:hover{
    color: black !important;
    cursor: pointer;
  }
  .manage-boder{
    border-bottom: 1px solid #E9E9E3;
    border-top: 1px solid #E9E9E3;
  }
  .border-radius0{
        border-radius:0px !important ;
  }
  .font1{
        font-size: 13px !important;
     
      }
      .font-bold1{
        font-weight: bold;
      }
      .manage-boder{
      border-bottom: 2px solid #E9E9E3;
      border-top: 2px solid #E9E9E3;
      padding-bottom: 10px !important;
      padding-top: 10px !important;
      
      }
      .font1{
        font-size: 13px !important;
     
      }
      .font-bold1{
        font-weight: bold !important;
      }
      .colr1{
          color:#A5A5A3;
          
      }
      .decoration{
      text-decoration: none;
      color:#A5A5A3  ;
    }
    .width7{
      width: 250px;
    }
    .bg-mycoolor{
      background-color: #a4d2f3 !important;

    }
   
  .modal-footer{
    text-align: right !important;
    display: block;
  }
  
  </style>